import { render, staticRenderFns } from "./userModBtn2.vue?vue&type=template&id=2e9fedda&"
import script from "./userModBtn2.vue?vue&type=script&lang=js&"
export * from "./userModBtn2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports